let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g0ZxT")).then(() => parcelRequire('9feT0'));